import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import getUserId from 'utils/session/getUserId';
import { TYPE_AVATAR } from 'utils/file/types';
import { useUploadFile } from 'actions/file';
import { setAlert, setSuccessAlert } from 'actions/alerts';
import userProfileKeys from './queryKeys';
import { scaleImage } from 'utils/image/scaleImage';
var AVATAR_UPLOAD_SIZE_PX = 512;
function useUploadAvatar() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  var _useUploadFile = useUploadFile({
      onSetAlert: function onSetAlert(options) {
        return setAlert(_objectSpread({
          key: 'upload-avatar',
          title: t('profile_avatar_uploading_alert_title')
        }, options));
      },
      onSuccess: function onSuccess() {
        return queryClient.invalidateQueries({
          queryKey: userProfileKeys.userProfile
        }).then(function () {
          setSuccessAlert({
            key: 'upload-avatar',
            title: t('profile_avatar_updated_alert_title')
          });
        });
      }
    }),
    uploadFile = _useUploadFile.uploadFile,
    isPending = _useUploadFile.isPending,
    isError = _useUploadFile.isError;
  function uploadAvatar(_x) {
    return _uploadAvatar.apply(this, arguments);
  }
  function _uploadAvatar() {
    _uploadAvatar = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
      var resizedImage;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (file) {
              _context.next = 1;
              break;
            }
            setAlert({
              key: 'upload-avatar',
              title: t('alert_nothing_to_upload')
            });
            return _context.abrupt("return");
          case 1:
            _context.next = 2;
            return scaleImage(file, {
              width: AVATAR_UPLOAD_SIZE_PX,
              height: AVATAR_UPLOAD_SIZE_PX
            });
          case 2:
            resizedImage = _context.sent;
            uploadFile({
              file: resizedImage || file,
              referenceId: getUserId(),
              type: TYPE_AVATAR
            });
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _uploadAvatar.apply(this, arguments);
  }
  return {
    isPending: isPending,
    isError: isError,
    uploadAvatar: uploadAvatar
  };
}
export default useUploadAvatar;